import { gql } from '@apollo/client/core';

export const hasActiveConsent = gql`
  query HasActiveConsent($orgId: String!) {
    hasActiveConsent(orgId: $orgId)
  }
`;

export const giveConsent = gql`
  mutation GiveConsent($orgId: String) {
    giveConsent(orgId: $orgId) {
      id
      policyVersion
      basis
      retentionExpiry
      isActive
      createdAt
      organization {
        id
        name
        avatar
      }
    }
  }
`;

export const organizationActiveConsents = gql`
  query OrganizationActiveConsents($orgId: String) {
    organizationActiveConsents(orgId: $orgId) {
      id
      policyVersion
      basis
      retentionExpiry
      isActive
      createdAt
      user {
        id
        firstname
        lastname
        avatar
      }
    }
  }
`;

// Web app Settings: the signed-in person's consents and notification preferences
export const myConsents = gql`
  query MyConsents {
    myConsents {
      id
      organizationId
      isActive
      timestamp
      organization {
        id
        name
        avatar
      }
    }
  }
`;

export const toggleConsent = gql`
  mutation ToggleConsent($orgId: String) {
    toggleConsent(orgId: $orgId) {
      id
      organizationId
      isActive
    }
  }
`;

export const getNotificationPreferences = gql`
  query GetNotificationPreferences {
    getNotificationPreferences {
      marketingEnabled
      eventsEnabled
      smsEnabled
      systemEnabled
    }
  }
`;

export const updateNotificationPreferences = gql`
  mutation UpdateNotificationPreferences($input: notificationPreferencesInput) {
    updateNotificationPreferences(input: $input) {
      marketingEnabled
      eventsEnabled
      smsEnabled
      systemEnabled
    }
  }
`;
